/**
 * Dilnaaz Crafts - Shopify Online Store 2.0 Theme JS
 */

// Ensure window.fetch is writable and has a setter if defined with only a getter in sandboxed environments
(function () {
  try {
    var _origFetch = window.fetch;
    try {
      Object.defineProperty(window, 'fetch', {
        get: function () { return _origFetch; },
        set: function (fn) { _origFetch = fn; },
        configurable: true,
        enumerable: true
      });
    } catch (e) {}
    if (typeof Window !== 'undefined' && Window.prototype) {
      try {
        Object.defineProperty(Window.prototype, 'fetch', {
          get: function () { return _origFetch; },
          set: function (fn) { _origFetch = fn; },
          configurable: true,
          enumerable: true
        });
      } catch (e2) {}
    }
  } catch (err) {}
})();

(function () {
  'use strict';

  // --- Header Scroll Effect ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    }, { passive: true });
  }

  // --- Cart Drawer Logic ---
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const openCartButtons = document.querySelectorAll('[data-cart-drawer-trigger]');
  const closeCartButtons = document.querySelectorAll('[data-cart-drawer-close]');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      fetchCart();
      cartDrawer.classList.add('is-active');
      cartOverlay.classList.add('is-active');
      document.body.classList.add('cart-drawer-open', 'overflow-hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('is-active');
      cartOverlay.classList.remove('is-active');
      document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
      document.body.style.overflow = '';
    }
  }

  openCartButtons.forEach(btn => btn.addEventListener('click', function(e) {
    e.preventDefault();
    openCart();
  }));

  closeCartButtons.forEach(btn => btn.addEventListener('click', function(e) {
    e.preventDefault();
    closeCart();
  }));

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  // --- Fetch Cart and Render Items ---
  window.fetchCart = function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(err => console.error('Error fetching cart:', err));
  };

  function updateCartCount(count) {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    const itemsContainer = document.getElementById('CartDrawerItems');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    const emptyState = document.getElementById('CartDrawerEmpty');
    const footer = document.getElementById('CartDrawerFooter');

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      if (emptyState) emptyState.style.display = 'block';
      if (itemsContainer) itemsContainer.innerHTML = '';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (footer) footer.style.display = 'block';

    const formattedSubtotal = (cart.total_price / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: cart.currency || 'INR',
      maximumFractionDigits: 0
    });
    if (subtotalEl) subtotalEl.textContent = formattedSubtotal;

    let html = '';
    cart.items.forEach((item, index) => {
      const itemPrice = (item.final_line_price / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: cart.currency || 'INR',
        maximumFractionDigits: 0
      });

      let propertiesHtml = '';
      if (item.properties) {
        for (const [key, val] of Object.entries(item.properties)) {
          if (val && !key.startsWith('_')) {
            propertiesHtml += `<div style="font-size: 0.6875rem; color: #8A6D56;"><strong>${key}:</strong> ${val}</div>`;
          }
        }
      }

      html += `
        <div style="display: flex; gap: 0.75rem; padding-bottom: 0.75rem; margin-bottom: 0.75rem; border-bottom: 1px solid #EDE5DA;">
          <div style="width: 4.5rem; height: 4.5rem; border-radius: 0.5rem; overflow: hidden; background: #F5EFEB; flex-shrink: 0;">
            <img src="${item.image}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: cover;">
          </div>
          <div style="flex: 1;">
            <div style="font-size: 0.8125rem; font-weight: 700; color: #1F1F1D;">${item.product_title}</div>
            ${item.variant_title ? `<div style="font-size: 0.6875rem; color: #8A8378;">${item.variant_title}</div>` : ''}
            ${propertiesHtml}
            <div style="font-size: 0.8125rem; font-weight: 600; margin-top: 0.25rem;">${itemPrice}</div>
            
            <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 0.5rem;">
              <div style="display: flex; align-items: center; border: 1px solid #EDE5DA; border-radius: 9999px; overflow: hidden;">
                <button onclick="updateCartLine(${index + 1}, ${item.quantity - 1})" style="padding: 0.25rem 0.5rem; font-size: 0.75rem;">-</button>
                <span style="padding: 0.25rem 0.5rem; font-size: 0.75rem; font-weight: 600;">${item.quantity}</span>
                <button onclick="updateCartLine(${index + 1}, ${item.quantity + 1})" style="padding: 0.25rem 0.5rem; font-size: 0.75rem;">+</button>
              </div>
              <button onclick="updateCartLine(${index + 1}, 0)" style="font-size: 0.6875rem; color: #C06C68; text-decoration: underline;">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = html;
  }

  window.updateCartLine = function (line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(res => res.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(err => console.error('Error updating cart:', err));
  };

  // --- AJAX Add to Cart for Forms ---
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(item => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
          openCart();
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
          // Fallback to standard form submit
          form.submit();
        });
    }
  });

  // --- FAQ Accordion ---
  const faqButtons = document.querySelectorAll('.faq-trigger');
  faqButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = content.style.display !== 'none';
      document.querySelectorAll('.faq-content').forEach(c => c.style.display = 'none');
      if (!isOpen) {
        content.style.display = 'block';
      }
    });
  });

  // --- Search Modal Logic ---
  const searchModal = document.getElementById('SearchModal');
  const searchOverlay = document.getElementById('SearchModalOverlay');
  const openSearchButtons = document.querySelectorAll('[data-search-trigger]');
  const closeSearchButtons = document.querySelectorAll('[data-search-close]');

  function openSearch() {
    if (searchModal && searchOverlay) {
      searchModal.classList.add('is-active');
      searchOverlay.classList.add('is-active');
      document.body.classList.add('modal-open');
      const input = searchModal.querySelector('input[type="search"]');
      if (input) setTimeout(() => input.focus(), 100);
    }
  }

  function closeSearch() {
    if (searchModal && searchOverlay) {
      searchModal.classList.remove('is-active');
      searchOverlay.classList.remove('is-active');
      document.body.classList.remove('modal-open');
    }
  }

  openSearchButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    openSearch();
  }));

  closeSearchButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    closeSearch();
  }));

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  // --- Mobile Drawer Toggle ---
  const mobileNav = document.getElementById('MobileNavDrawer');
  const mobileNavOverlay = document.getElementById('MobileNavOverlay');
  const openMobileNavButtons = document.querySelectorAll('[data-mobile-nav-trigger]');
  const closeMobileNavButtons = document.querySelectorAll('[data-mobile-nav-close]');

  function openMobileNav() {
    if (mobileNav && mobileNavOverlay) {
      mobileNav.classList.add('is-active');
      mobileNavOverlay.classList.add('is-active');
      document.body.classList.add('mobile-nav-open', 'overflow-hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    if (mobileNav && mobileNavOverlay) {
      mobileNav.classList.remove('is-active');
      mobileNavOverlay.classList.remove('is-active');
      document.body.classList.remove('mobile-nav-open', 'overflow-hidden');
      document.body.style.overflow = '';
    }
  }

  openMobileNavButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    openMobileNav();
  }));

  closeMobileNavButtons.forEach(btn => btn.addEventListener('click', function (e) {
    e.preventDefault();
    closeMobileNav();
  }));

  if (mobileNavOverlay) {
    mobileNavOverlay.addEventListener('click', closeMobileNav);
  }

  // Keyboard accessibility: Close modals/drawers on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (cartDrawer && cartDrawer.classList.contains('is-active')) closeCart();
      if (mobileNav && mobileNav.classList.contains('is-active')) closeMobileNav();
      if (searchModal && searchModal.classList.contains('is-active')) closeSearch();
    }
  });

  // --- Shopify Online Store 2.0 Section Rendering API Helper ---
  window.SectionRenderer = {
    /**
     * Fetch a single section HTML by section ID
     * @param {string} sectionId - The section name or ID (e.g. 'cart-drawer', 'header')
     * @param {string} [url] - The path to request against (default: current page)
     * @param {Object} [params] - Query parameters
     * @returns {Promise<string>}
     */
    async renderSection(sectionId, url = window.location.pathname, params = {}) {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      for (const [key, value] of Object.entries(params)) {
        fetchUrl.searchParams.set(key, value);
      }
      const res = await fetch(fetchUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) throw new Error('Failed to render section: ' + sectionId);
      return await res.text();
    },

    /**
     * Fetch multiple sections simultaneously via Section Rendering API
     * @param {string[]} sectionIds - Array of section IDs (e.g. ['cart-drawer', 'header'])
     * @param {string} [url] - The path to request against
     * @returns {Promise<Record<string, string>>}
     */
    async renderSections(sectionIds, url = window.location.pathname) {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('sections', sectionIds.join(','));
      const res = await fetch(fetchUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) throw new Error('Failed to render sections');
      return await res.json();
    },

    /**
     * Replace an existing section's DOM element with newly rendered section HTML
     * @param {string} sectionId - The section ID
     * @param {string} htmlString - Raw HTML returned by Section Rendering API
     */
    replaceSection(sectionId, htmlString) {
      const target = document.getElementById('shopify-section-' + sectionId) ||
                     document.querySelector('[data-section-id="' + sectionId + '"]') ||
                     document.querySelector('.' + sectionId);
      if (!target) return null;

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const newEl = doc.getElementById('shopify-section-' + sectionId) || doc.body.firstElementChild;
      if (newEl) {
        target.replaceWith(newEl);
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          detail: { sectionId: sectionId }
        }));
        return newEl;
      }
      return null;
    }
  };

  // --- Shopify Theme Editor Lifecycle Events Support ---
  document.addEventListener('shopify:section:load', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    // Re-bind accordions, triggers, and carousels when a section reloads in Theme Customizer
    document.querySelectorAll('.faq-trigger').forEach(btn => {
      btn.onclick = function () {
        const content = this.nextElementSibling;
        const isOpen = content.style.display !== 'none';
        document.querySelectorAll('.faq-content').forEach(c => c.style.display = 'none');
        if (!isOpen) content.style.display = 'block';
      };
    });
  });

  // Initial cart count fetch
  if (document.querySelector('[data-cart-count]')) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(() => {});
  }
})();
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll(
    '.section-padding, .category-card, .product-card'
  );

  if (!items.length) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dc-reveal', 'dc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12
  });

  items.forEach(function (item) {
    item.classList.add('dc-reveal');
    observer.observe(item);
  });
});